import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const sections = [
  {
    id: "editeur",
    title: "Éditeur du site",
    content: "Le site vfactions.eu est édité par VF ACTIONS, société par actions simplifiée unipersonnelle (SASU).\nSIREN : 988 144 622 — R.C.S. Brest\nSiège social : 12 Rue Jacques Andrieux, 29270 Carhaix-Plouguer, France\nEmail : vferec29@gmail.com"
  },
  {
    id: "publication",
    title: "Directeur de la publication",
    content: "Le Président de VF ACTIONS."
  },
  {
    id: "hebergement",
    title: "Hébergement",
    content: "Le site est hébergé sur une infrastructure cloud sécurisée (Emergent). Les données sont hébergées en Europe."
  },
  {
    id: "propriete",
    title: "Propriété intellectuelle",
    content: "L'ensemble des contenus du site (textes, images, vidéos, logos, marques) est la propriété exclusive de VF ACTIONS, sauf mention contraire. Toute reproduction, totale ou partielle, sans autorisation préalable est interdite."
  },
  {
    id: "donnees",
    title: "Données personnelles & confidentialité",
    content: "Le traitement de vos données personnelles est détaillé dans notre Politique de confidentialité, accessible à l'adresse /confidentialite. Vous y trouverez les finalités, bases légales, durées de conservation et l'ensemble de vos droits (accès, rectification, effacement, opposition, portabilité).\nPour toute demande : vferec29@gmail.com."
  },
  {
    id: "cookies",
    title: "Cookies et mesure d'audience",
    content: "Le site utilise des cookies de mesure d'audience, déposés uniquement après votre consentement via le bandeau prévu à cet effet. Vous pouvez modifier votre choix à tout moment depuis la Politique de confidentialité."
  }
];

export default function LegalPage() {
  return (
    <div className="min-h-screen bg-[#F6F4EC]" data-testid="legal-page">
      <header className="bg-[#0F4C4C]">
        <div className="max-w-4xl mx-auto px-6 lg:px-10">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="font-display text-xl font-bold text-white" data-testid="legal-logo-link">VF ACTIONS</Link>
            <Link to="/" data-testid="legal-back-link" className="inline-flex items-center gap-2 text-sm text-white/80 hover:text-[#F5B800] transition-colors">
              <ArrowLeft size={16} /> Retour au site
            </Link>
          </div>
          <div className="py-12">
            <h1 className="font-display text-4xl font-bold text-white">Mentions légales</h1>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 lg:px-10 py-16">
        <div className="space-y-10">
          {sections.map((s) => (
            <section key={s.id} id={s.id} data-testid={`legal-section-${s.id}`}>
              <h2 className="font-display text-xl font-bold text-[#142828] mb-3">{s.title}</h2>
              <p className="text-sm text-[#516969] leading-relaxed whitespace-pre-line">{s.content}</p>
            </section>
          ))}
        </div>
        <Link to="/confidentialite" data-testid="legal-privacy-link" className="inline-block mt-10 text-sm font-bold text-[#0F4C4C] underline underline-offset-4 hover:text-[#C49000] transition-colors">
          Consulter la politique de confidentialité →
        </Link>
        <p className="text-xs text-[#516969] italic mt-12">Dernière mise à jour : {new Date().toLocaleDateString("fr-FR", { month: "long", year: "numeric" })}</p>
      </main>

      <footer className="bg-[#082A2A] py-8">
        <p className="text-center text-xs text-white/50">© {new Date().getFullYear()} VF ACTIONS</p>
      </footer>
    </div>
  );
}
